import type { AssessorDateWindow } from '@app-types';

/** Statuses counted as "Open Assessment": the Assessor still has work on them. */
const OPEN_ASSESSMENT_STATUSES = 'Pending,Pending Evidence,Evidence Past Due,Escalated';
const ESCALATED_STATUSES = 'Evidence Past Due,Escalated';
const MIN_ESCALATED_LEVEL = '2';

function route(path: string, params: Record<string, string>): string {
  return `${path}?${new URLSearchParams(params)}`;
}

/**
 * Where each Assessor launch-page tile navigates. Every target lists exactly the items its tile
 * counts, so dates come from the endpoint's own window and are never recomputed in the browser.
 */
export function buildAssessorDashboardRoutes(window: AssessorDateWindow, userId: number) {
  const me = String(userId);
  const myMeetings = { processedByMe: 'true' };

  return {
    meetingsToday: route('/assessor/meetings', {
      ...myMeetings,
      openOnly: 'true',
      dateFrom: window.today,
      dateTo: window.today
    }),
    meetingsNext5Days: route('/assessor/meetings', {
      ...myMeetings,
      openOnly: 'true',
      dateFrom: window.next_5_days_from,
      dateTo: window.next_5_days_to
    }),
    assessmentsOpen: route('/assessments', { assessor_id: me, status: OPEN_ASSESSMENT_STATUSES }),
    meetingsInConflict: route('/assessor/meetings', { ...myMeetings, state: 'conflicts', openOnly: 'true' }),
    meetingsPendingReschedule: route('/assessor/meetings', { ...myMeetings, state: 'overdue' }),
    scheduledMeetings: route('/assessor/meetings', { ...myMeetings, state: 'active' }),
    assessmentsPendingPublishing: route('/assessments', {
      assessor_id: me,
      status: 'Pending',
      meeting_date_to: window.today
    }),
    evidencePendingReview: '/evidence-review?status=pending',
    assessmentsDueSoon: route('/assessments', {
      assessor_id: me,
      status: 'Pending Evidence',
      evidence_due_from: window.due_soon_from,
      evidence_due_to: window.due_soon_to
    }),
    assessmentsPastDue: route('/assessments', { assessor_id: me, status: 'Evidence Past Due' }),
    assessmentsEscalated: route('/assessments', {
      assessor_id: me,
      status: ESCALATED_STATUSES,
      min_escalation_level: MIN_ESCALATED_LEVEL
    })
  };
}

export type AssessorDashboardRoutes = ReturnType<typeof buildAssessorDashboardRoutes>;
